import styled from 'styled-components';

const FlexSpacer = styled.div`
	flex-grow: 1;
`;

export default FlexSpacer;
